module.exports = __webpack_public_path__ + "static/najhrabriji-miš-na-svijetu-c2bc9ef1fb90d6c6fbb97adb8f592164.png";